import React, {ReactNode} from 'react';
import { Navigate } from 'react-router-dom';

import {LS} from "../../utils";
import {LS_KEYS, ROUTES} from "../../types";

const { getFromLS } = LS;

const PublicRoute = ({ component }: { component: ReactNode }) => {
  const isAuth = getFromLS(LS_KEYS.ACCESS_TOKEN);

  if (isAuth) {
    return <Navigate to={ROUTES.APPLICATIONS} />;
  }

  return (
    <>
      {component}
    </>
  )
};

export default PublicRoute;
